import React  from 'react';
import './App.css';
import './Vendor.css';
import VendorLang from './VendorLang.json';

var newline = "\n";

class VendorAssessmentList extends React.Component {
	
	constructor(props) {

		super(props);
		
		this.uniqueID = "";

		this.state = {
			tab: "list",
			vendorJsonArray: null,
			selectedVendorIndex: -1,
			selectedOIB: -1,
			logText: "",
			phase: "",
			pptxFilename: "",
		}

		this.vendor1 = this.vendor1.bind(this);
		this.vendor2 = this.vendor2.bind(this);
		this.vendor3 = this.vendor3.bind(this);
		this.vendor4 = this.vendor4.bind(this);
		this.vendor5 = this.vendor5.bind(this);
	}
		
	componentDidMount() {
		this.serverGetVendorList();
	}
	
	async serverGetVendorList() {

		var baseURLAPI = this.props.baseURLAPI;
		var dataUrl = "/ht/PoslovnaHrvatska.xlsx";
		var url = baseURLAPI + "/dataconvertexceltojson?url=" + encodeURIComponent(dataUrl);
		
		var vendorJsonArray = null;
		
		try {
			var res = await fetch(url);
			vendorJsonArray = await res.json();
		} catch (err) {
		}

		if (vendorJsonArray === null) {
			return;
		}
		
		this.setState({
			vendorJsonArray: vendorJsonArray,
		});
	}
	
	async serverVendorAssessment(oib, phase) {

		var baseURLAPI = this.props.baseURLAPI;
		var dataUrl = "/ht/PoslovnaHrvatska.xlsx";
		var url = baseURLAPI + "/vendorassessment?oib=" + oib;
		url = url + "&uniqueid=" + this.uniqueID;
		url = url + "&phase=" + phase;
		console.log(url);
		
		var responseText = "";
		try {
			var res = await fetch(url);
			responseText = await await res.text();
		} catch (err) {
		}
		
		return responseText;
	}
	
	vendor1() {
		var logText = this.state.logText;
		logText = logText + this.props.getLang(VendorLang, "vendor1") + newline + newline;
		this.setState({
			phase: 1,
			logText: logText,
		});
		setTimeout(this.vendor2, 1000);
	}
	
	vendor2() {
		var logText = this.state.logText;
		logText = logText + this.props.getLang(VendorLang, "vendor2") + newline + newline;
		this.setState({
			phase: 2,
			logText: logText,
		});
		setTimeout(this.vendor3, 1000);
	}
	
	async vendor3() {

		var logText = this.state.logText;
		logText = logText + this.props.getLang(VendorLang, "vendor3") + newline + newline;
		this.setState({
			phase: 3,
			logText: logText,
		});

		var selectedOIB = this.state.selectedOIB;
		await this.serverVendorAssessment(selectedOIB, "llm");

		setTimeout(this.vendor4, 1000);
	}
	
	async vendor4() {

		var logText = this.state.logText;
		logText = logText + this.props.getLang(VendorLang, "vendor4") + newline + newline;
		this.setState({
			phase: 4,
			logText: logText,
		});

		var selectedOIB = this.state.selectedOIB;
		var pptxFilename = await this.serverVendorAssessment(selectedOIB, "pptx");
		this.setState({
			pptxFilename: pptxFilename,
		});

		setTimeout(this.vendor5, 1000);
	}
	
	vendor5() {
		var logText = this.state.logText;
		logText = logText + this.props.getLang(VendorLang, "vendor5") + newline + newline;
		this.setState({
			phase: 5,
			logText: logText,
		});
	}
	
	onClickVendor(vendorIndex) {

		var vendorJsonArray = this.state.vendorJsonArray;
		var itemObj = vendorJsonArray[vendorIndex];
		var oib = itemObj.oib;

		this.uniqueID = Date.now();
		this.setState({
			tab: "view",
			selectedVendorIndex: vendorIndex,
			selectedOIB: oib,
		});

		var logText = this.props.getLang(VendorLang, "vendor0") + newline + newline;
		this.setState({logText: logText});

		setTimeout(this.vendor1, 1000);
	}
	
	onClickBackToList() {
		this.uniqueID = "";
		this.setState({
			phase: -1,
			pptxFilename: "",
			tab: "list",
			selectedVendorIndex: -1,
		});
	}

	renderOneVendor(index, itemObj) {
		
		var key = "key-" + index;
		var companyName = itemObj.companyName;
		
		return (
			<div key={key} className="VendorListCompanyNameItem" onClick={() => this.onClickVendor(index)}>
				{companyName}
			</div>
		);
	}
		
	renderAllVendors() {
		
		var vendorJsonArray = this.state.vendorJsonArray;
		if (vendorJsonArray === null) {
			return;
		}
		
		var i;
		var itemObj;
		var jsxCode;
		var jsxArray = [];
		
		for(i=0; i<vendorJsonArray.length; i++) {
			itemObj = vendorJsonArray[i];
			jsxCode = this.renderOneVendor(i, itemObj);
			jsxArray.push(jsxCode);
		}
		
		return (
			<div>
				<div className="VendorListTopTitle">{this.props.getLang(VendorLang, "vendorMainTopTitle")}</div>
				<div style={{height: "20px"}}></div>
				{jsxArray}
			</div>
		);
	}
	
	renderPPTXLink() {
		
		var phase = this.state.phase;
		
		if (phase !== 5) {
			return;
		}

		var baseURLAPI = this.props.baseURLAPI;
		var uniqueID = this.uniqueID;
		var pptxFilename = this.state.pptxFilename;
		var pptxURL = baseURLAPI + "/pptx/" + uniqueID + "/" + pptxFilename;

		return (
			<div>
				<div style={{height: "20px"}}></div>
				<a href={pptxURL}>{pptxFilename}</a>
			</div>
		);
	}
	
	renderVendorAssessment() {

		var vendorJsonArray = this.state.vendorJsonArray;
		var selectedVendorIndex = this.state.selectedVendorIndex;
		var itemObj = vendorJsonArray[selectedVendorIndex];
		var companyName = itemObj.companyName;
		var oib = itemObj.oib;
		
		var logText = this.state.logText;
		var logText2 = this.props.convertTextNewlineToBr(logText);

		return (
			<div>
				<div className="VendorListTopTitle">{companyName} - OIB: {oib}</div>
				<div style={{height: "20px"}}></div>
				<div className="VendorListLogText">	
					{logText2}
				</div>
				{this.renderPPTXLink()}
				<div style={{height: "30px"}}></div>
				<button className="VendorListGreyButton" onClick={() => this.onClickBackToList()}>{this.props.getLang(VendorLang, "backToList")}</button>
				<div style={{height: "30px"}}></div>
			</div>
		);
	}

	renderTab() {
		
		var tab = this.state.tab;
		
		if (tab === "list") {
			return this.renderAllVendors();
		}

		if (tab === "view") {
			return this.renderVendorAssessment();
		}
	}

	render() {

		var companyID = this.props.companyID;
		if (companyID !== 104) {
			return;
		}

		return (
			<div className="VendorListTopContainer">
				<div style={{height: "20px"}}></div>
				{this.renderTab()}
				<div style={{height: "20px"}}></div>
			</div>
		);
	}
}

export default VendorAssessmentList;

